'use client';

import { getWindow } from '@bss-portfolio-view-ui/shared-common-util-browser';
import { useFeatureFlag } from '../use-feature-flag/use-feature-flag';

type UseFeatureFlagOn = {
  enabled: boolean;
  isReady: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  config: any;
};

export const getUriFlag = (featureFlag: string) => {
  const window = getWindow();
  if (window && window.location.hostname === 'localhost') {
    return new URLSearchParams(window.location.search).get(featureFlag);
  } else {
    return null;
  }
};

export const useFeatureFlagOn = (featureFlag: string): UseFeatureFlagOn => {
  const uriFlag = getUriFlag(featureFlag);
  const { treatment, isReady, config } = useFeatureFlag(featureFlag);

  return {
    enabled: !!uriFlag || treatment === 'on',
    isReady,
    config,
  };
};
